import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";

import { Constants } from "../../shared/constants/constants";
import { AdaaHelper } from "../utils";

function entityTypeGuard(isPMO: boolean): CanActivateFn {
  return (): boolean | UrlTree => {
    const router = inject(Router);

    if (isPMO) return AdaaHelper.isPMOEntity() ? true : router.createUrlTree(["/403"]);
    else return !AdaaHelper.isPMOEntity() ? true : router.createUrlTree(["/403"]);
  };
}

export const pmoEntity = entityTypeGuard(true);
export const notPmoEntity = entityTypeGuard(false);

export function getCurrentEntityType(): number {
  return +AdaaHelper.getLocalStorage(Constants.localStorageKeys.currentEntity, {
    type: "prop",
    property: "entityType",
  });
}

function blockEntityTypes(blockedTypes: number[]): CanActivateFn {
  return (): boolean | UrlTree => {
    const router = inject(Router);

    return blockedTypes.includes(getCurrentEntityType()) ? router.createUrlTree(["/403"]) : true;
  };
}

export const notExternalEntity = blockEntityTypes([Constants.ENTITY_TYPES.EXTERNAL]);
export const notExternalOrParticipatingEntity = blockEntityTypes([
  Constants.ENTITY_TYPES.EXTERNAL,
  Constants.ENTITY_TYPES.PARTICIPATING,
]);
